import { SegmentController } from "components/designV2/segmentcontroller/segmentcontroller";
import { useTranslation } from "react-i18next";
import { ColorV2 } from "config/colors";
import { Tag } from "components/designV2/tag/tag";
import type { ProfilePanelTab } from "../profilePanel.contract";
import { TabsRow } from "./profilePanel.styled";

interface ProfilePanelTabsProps {
  value: ProfilePanelTab;
  onChange: (value: string) => void;
}

/**
 * Handles profile panel tabs.
 */
export const ProfilePanelTabs = (props: ProfilePanelTabsProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <TabsRow>
      <SegmentController
        options={[
          {
            value: "profile",
            label: t("Staff.ProfilePanelTabProfile"),
          },
          {
            value: "employmentSalary",
            label: t("Staff.ProfilePanelTabEmploymentSalary"),
          },
          {
            value: "history",
            label: t("General.History"),
          },
          {
            value: "agreements",
            label: (
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                {t("Staff.ProfilePanelTabAgreements")}
                <Tag
                  text={t("General.New")}
                  backgroundColor={ColorV2.UnplannedAbsenceYellow}
                  textColor={ColorV2.DarkAmbigiousYellow}
                />
              </span>
            ),
          },
        ]}
        value={props.value}
        onChange={props.onChange}
      />
    </TabsRow>
  );
};
